import { AxiosError } from "axios";
import { TokenStorage } from "../core/http-axios-react/http/Token";
import { useToast } from "../context/toast/ToastContext";

interface IResponseDataError {
  message: string;
}

export const useErrorHandler = () => {
  const toast = useToast();

  const redirectOnTokenExpired = (
    error: AxiosError<IResponseDataError | any>
  ) => {
    const message = error.response?.data.message;
    if (
      message === "Token has expired" ||
      message === "Token Signature could not be verified."
    ) {
      TokenStorage.clear();
      window.location.reload();
    }
  };

  const showToastOnError = (error: AxiosError<IResponseDataError | any>) => {
    let message = "";
    if (error.response?.data?.errors) {
      if (Array.isArray(error.response?.data?.errors)) {
        error.response?.data?.errors.forEach((item: string) => {
          message += `${item} `;
        });
      }
    } else if (error.response?.data?.message) {
      message = error.response?.data?.message;
    } else {
      message = "Terjadi kesalahan, Mohon coba beberapa saat kembali";
    }
    toast.show(message, "error");
  };

  return {
    redirectOnTokenExpired,
    showToastOnError,
  };
};
